import { useRouter } from 'next/router';
import { useEffect } from 'react';

export default function Pricing() {
  const router = useRouter();
  useEffect(() => {
    router.replace('/plans-and-pricing');
  }, [router]);
  return null;
}
